"use strict"; // To modify this file, you must update ./misc/admin/lib/cmds/update-exports.js

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BaseContract", {
  enumerable: true,
  get: function get() {
    return ethers.BaseContract;
  }
});
Object.defineProperty(exports, "BigNumber", {
  enumerable: true,
  get: function get() {
    return ethers.BigNumber;
  }
});
Object.defineProperty(exports, "Contract", {
  enumerable: true,
  get: function get() {
    return ethers.Contract;
  }
});
Object.defineProperty(exports, "ContractFactory", {
  enumerable: true,
  get: function get() {
    return ethers.ContractFactory;
  }
});
Object.defineProperty(exports, "FixedNumber", {
  enumerable: true,
  get: function get() {
    return ethers.FixedNumber;
  }
});
Object.defineProperty(exports, "Signer", {
  enumerable: true,
  get: function get() {
    return ethers.Signer;
  }
});
Object.defineProperty(exports, "VoidSigner", {
  enumerable: true,
  get: function get() {
    return ethers.VoidSigner;
  }
});
Object.defineProperty(exports, "Wallet", {
  enumerable: true,
  get: function get() {
    return ethers.Wallet;
  }
});
Object.defineProperty(exports, "Wordlist", {
  enumerable: true,
  get: function get() {
    return ethers.Wordlist;
  }
});
Object.defineProperty(exports, "constants", {
  enumerable: true,
  get: function get() {
    return ethers.constants;
  }
});
Object.defineProperty(exports, "errors", {
  enumerable: true,
  get: function get() {
    return ethers.errors;
  }
});
exports.ethers = void 0;
Object.defineProperty(exports, "getDefaultProvider", {
  enumerable: true,
  get: function get() {
    return ethers.getDefaultProvider;
  }
});
Object.defineProperty(exports, "logger", {
  enumerable: true,
  get: function get() {
    return ethers.logger;
  }
});
Object.defineProperty(exports, "providers", {
  enumerable: true,
  get: function get() {
    return ethers.providers;
  }
});
Object.defineProperty(exports, "utils", {
  enumerable: true,
  get: function get() {
    return ethers.utils;
  }
});
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function get() {
    return ethers.version;
  }
});
Object.defineProperty(exports, "wordlists", {
  enumerable: true,
  get: function get() {
    return ethers.wordlists;
  }
});

var ethers = _interopRequireWildcard(require("./ethers"));

exports.ethers = ethers;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

try {
  var anyGlobal = window;

  if (anyGlobal._ethers == null) {
    anyGlobal._ethers = ethers;
  }
} catch (error) {}